export const categories = [
  {
    key: 'shoes',
    nameKey: 'category_shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    img: 'https://readdy.ai/api/search-image?query=Single%20pair%20of%20clean%20white%20minimalist%20sneakers%20product%20photography%2C%20soft%20mint%20green%20pastel%20background%2C%20bright%20studio%20lighting%2C%20side%20profile%20view%2C%20fresh%20airy%20aesthetic%2C%20high%20detail%20shoe%20photography&width=600&height=450&seq=cat-shoes&orientation=landscape',
  },
  {
    key: 'hoodies',
    nameKey: 'category_hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    img: 'https://readdy.ai/api/search-image?query=Oversized%20beige%20hoodie%20product%20photography%20hanging%20on%20minimal%20wooden%20hanger%2C%20warm%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20cozy%20streetwear%2C%20clean%20minimal%20aesthetic&width=600&height=450&seq=cat-hoodies&orientation=landscape',
  },
  {
    key: 'tshirts',
    nameKey: 'category_tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    img: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20pastel%20pink%20t-shirts%20stacked%20product%20photography%2C%20clean%20white%20studio%20background%2C%20soft%20lighting%2C%20minimal%20apparel%20display%2C%20fresh%20airy%20style&width=600&height=450&seq=cat-tshirts&orientation=landscape',
  },
  {
    key: 'jackets',
    nameKey: 'category_jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-user-line',
    img: 'https://readdy.ai/api/search-image?query=Classic%20blue%20denim%20jacket%20product%20photography%20laid%20flat%2C%20soft%20sky%20blue%20pastel%20background%2C%20bright%20studio%20lighting%2C%20clean%20minimal%20outerwear%20aesthetic&width=600&height=450&seq=cat-jackets&orientation=landscape',
  },
  {
    key: 'pants',
    nameKey: 'category_pants',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-walk-line',
    img: 'https://readdy.ai/api/search-image?query=Folded%20beige%20cargo%20pants%20product%20photography%2C%20warm%20sand%20colored%20background%2C%20soft%20natural%20lighting%2C%20minimal%20apparel%20flatlay%2C%20clean%20aesthetic&width=600&height=450&seq=cat-pants&orientation=landscape',
  },
  {
    key: 'headwear',
    nameKey: 'category_headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-star-line',
    img: 'https://readdy.ai/api/search-image?query=Single%20baseball%20cap%20product%20photography%2C%20soft%20butter%20yellow%20pastel%20background%2C%20bright%20studio%20lighting%2C%20minimal%20headwear%2C%20clean%20fresh%20aesthetic&width=600&height=450&seq=cat-headwear&orientation=landscape',
  },
  {
    key: 'sets',
    nameKey: 'category_sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-layout-grid-line',
    img: 'https://readdy.ai/api/search-image?query=Matching%20coordinated%20streetwear%20outfit%20set%20flatlay%2C%20hoodie%20and%20joggers%20on%20neutral%20light%20grey%20background%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20aesthetic&width=600&height=450&seq=cat-sets&orientation=landscape',
  },
  {
    key: 'underwear',
    nameKey: 'category_underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-shield-line',
    img: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20white%20cotton%20underwear%20product%20photography%2C%20soft%20neutral%20beige%20background%2C%20bright%20clean%20studio%20lighting%2C%20fresh%20minimal%20aesthetic&width=600&height=450&seq=cat-underwear&orientation=landscape',
  },
  {
    key: 'jersey',
    nameKey: 'category_jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-t-shirt-fill',
    img: 'https://readdy.ai/api/search-image?query=Athletic%20sports%20jersey%20product%20photography%2C%20soft%20sage%20green%20pastel%20background%2C%20bright%20studio%20lighting%2C%20clean%20minimal%20sportswear%20aesthetic&width=600&height=450&seq=cat-jersey&orientation=landscape',
  },
  {
    key: 'accessories',
    nameKey: 'category_accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-gift-line',
    img: 'https://readdy.ai/api/search-image?query=Minimalist%20wristwatch%20and%20sunglasses%20product%20photography%2C%20soft%20peach%20pastel%20background%2C%20bright%20studio%20lighting%2C%20luxury%20accessories%2C%20clean%20aesthetic&width=600&height=450&seq=cat-accessories&orientation=landscape',
  },
  {
    key: 'bags',
    nameKey: 'category_bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    img: 'https://readdy.ai/api/search-image?query=Leather%20tote%20handbag%20product%20photography%2C%20soft%20lavender%20pastel%20background%2C%20bright%20studio%20lighting%2C%20minimal%20bag%2C%20clean%20elegant%20aesthetic&width=600&height=450&seq=cat-bags&orientation=landscape',
  },
  {
    key: 'belts',
    nameKey: 'category_belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-vip-diamond-line',
    img: 'https://readdy.ai/api/search-image?query=Coiled%20leather%20belt%20product%20photography%2C%20warm%20terracotta%20background%2C%20soft%20studio%20lighting%2C%20minimal%20accessory%2C%20clean%20aesthetic&width=600&height=450&seq=cat-belts&orientation=landscape',
  },
  {
    key: 'perfumes',
    nameKey: 'category_perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-windy-line',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20product%20photography%2C%20soft%20rose%20pastel%20background%2C%20bright%20studio%20lighting%2C%20minimal%20fragrance%2C%20clean%20aesthetic&width=600&height=450&seq=cat-perfumes&orientation=landscape',
  },
  {
    key: 'other',
    nameKey: 'category_other',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    img: 'https://readdy.ai/api/search-image?query=Assorted%20small%20accessories%20flatlay%20with%20wallet%20keys%20and%20phone%20case%2C%20soft%20teal%20pastel%20background%2C%20bright%20studio%20lighting%2C%20clean%20minimal%20aesthetic&width=600&height=450&seq=cat-other&orientation=landscape',
  },
];